import { ImageOptions, ModifyImageSettings } from "../../types/imageTypes";
import { useDispatchBaseEvent, useSubscribeToBaseEvent } from "../useDispatchBaseEvent";

const CHANGE_IMAGE_OPTIONS_EVENT_NAME = "useChangeImageOptionsEvent";

export type ChangeImageOptionsEvent = {
  type: typeof CHANGE_IMAGE_OPTIONS_EVENT_NAME;
  payload: ImageOptions & ModifyImageSettings;
};

export function useDispatchChangeImageOptionsEvent() {
  return useDispatchBaseEvent<ChangeImageOptionsEvent>(CHANGE_IMAGE_OPTIONS_EVENT_NAME);
}

export function useSubscribeToChangeImageOptionsEvent(handler: (payload: ChangeImageOptionsEvent["payload"]) => void) {
  useSubscribeToBaseEvent<ChangeImageOptionsEvent>(CHANGE_IMAGE_OPTIONS_EVENT_NAME, handler);
}
